<script setup lang="ts">
  import MobilePrimaryButton from '@/shared/ui/MobilePrimaryButton.vue';
  import { useMobileSearchFlowContext } from '../../../model/useMobileSearchFlow';
  import MobileFieldCard from '../MobileFieldCard.vue';

  const flow = useMobileSearchFlowContext();
</script>

<template>
  <div
    class="mobile-main-screen"
    data-testid="search-form-mobile-main"
  >
    <slot name="header" />

    <div class="mobile-main-screen__sheet">
      <div class="mobile-main-screen__fields">
        <MobileFieldCard
          v-if="flow.isVisibleDeparture.value"
          :label="flow.texts.labels.departure"
          :value="flow.departureValue.value"
          :placeholder="flow.texts.placeholders.departure"
          testid="mobile-field-departure"
          @click="flow.editField('departure')"
        />

        <MobileFieldCard
          :label="flow.texts.labels.destination"
          :value="flow.destinationValue.value"
          :placeholder="flow.texts.placeholders.destination"
          testid="mobile-field-destination"
          @click="flow.editField('destination')"
        />

        <MobileFieldCard
          :label="flow.texts.labels.date"
          :value="flow.dateValue.value"
          :placeholder="flow.texts.placeholders.date"
          testid="mobile-field-date"
          @click="flow.editField('date')"
        />

        <MobileFieldCard
          :label="flow.texts.labels.nights"
          :value="flow.nightsValue.value"
          testid="mobile-field-nights"
          @click="flow.editField('nights')"
        />

        <MobileFieldCard
          :label="flow.texts.labels.tourists"
          :value="flow.touristsValue.value"
          testid="mobile-field-tourists"
          @click="flow.editField('tourists')"
        />
      </div>
      <div class="mobile-main-screen__container-buttons">
        <slot name="button-prepend"></slot>
        <MobilePrimaryButton
          testid="search-form-mobile-primary"
          @click="flow.submit"
        >
          {{ flow.primaryTexts.searchBtn }}
        </MobilePrimaryButton>
      </div>
      <slot name="footer" />
    </div>

    <slot name="pageFooter" />
  </div>
</template>

<style lang="scss" scoped>
  .mobile-main-screen {
    display: flex;
    flex: 1 1 auto;
    flex-direction: column;
    width: 100%;

    &__sheet {
      background: var(--color-slate-10);
      border-radius: 24px 24px 0 0;
      box-sizing: border-box;
      display: flex;
      flex: 1 1 auto;
      flex-direction: column;
      padding: var(--spacing-l) var(--spacing-m) var(--spacing-xxl);
      width: 100%;
    }

    &__container-buttons {
      display: flex;
      gap: var(--spacing-xs);
      margin-top: var(--spacing-m);
    }

    &__fields {
      display: flex;
      flex-direction: column;
      gap: var(--spacing-xs);
    }
  }
</style>
